import { useQuery } from '@tanstack/react-query';
import { listUsers } from './api';

const USERS_QUERY_KEY = ['users'];

/**
 * ユーザー一覧を取得するフック（管理者のみ）
 */
export function useUsers() {
  return useQuery({
    queryKey: USERS_QUERY_KEY,
    queryFn: listUsers,
  });
}
